import getCalendarSharingInitialState from '../selectors/getCalendarSharingInitialState';
import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
var assign = require('object-assign');
/**
 * Mutator to clear current state of shared calendars option store
 */
export default mutatorAction('discardSharedCalendarOption', function discardSharedCalendarOption() {
    var store = getStore();
    var initialState = getCalendarSharingInitialState();
    store.currentState = assign({}, initialState);
});
//# sourceMappingURL=discardSharedCalendarOption.js.map